<template>
  <v-table
    url="/api/v1/adminSupportMessage"
    :attributes="[
      {
        attribute: 'id',
        name: 'ID'
      },
      {
        attribute: 'from',
        name: 'Von',
        sortable: false
      },
      {
        attribute: 'moderator',
        name: 'An',
        type: 'UserCell',
        sortable: false
      },
      {
        attribute: 'message',
        name: 'Nachricht'
      },
      {
        name: 'Erstellt am',
        attribute: 'created_at',
        type: 'DateTimeCell'
      }
    ]"
    :filter="[
      {
        name: 'with',
        value: ['moderator', 'admin']
      }
    ]"
  ></v-table>
</template>

<script lang="babel">
export default {};
</script>
